import viewMessageTemplate from "./view_message.html";
import en from "./en.json";
import es from "./es.json";

export default {
    bindings: {
        announcement: "<",
        translated: "<",
        grower: "<",
        attachments: "<",
    },
    template: viewMessageTemplate,
    name: "viewMessage",
    translations: { en, es },
};
